import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ImageContextProps {
  logoUrl: string;
  setLogoUrl: React.Dispatch<React.SetStateAction<string>>;
}

const ImageContext = createContext<ImageContextProps | undefined>(undefined);

interface ImageProviderProps {
  children: ReactNode;
}

export const ImageProvider: React.FC<ImageProviderProps> = ({ children }) => {
  const [logoUrl, setLogoUrl] = useState<string>('/images/hinova-mobile.png');

  return (
    <ImageContext.Provider value={{ logoUrl, setLogoUrl }}>
      {children}
    </ImageContext.Provider>
  );
};

export const useImageContext = (): ImageContextProps => {
  const context = useContext(ImageContext);
  if (!context) {
    throw new Error('useImageContext precisa englobar o ImageProvider');
  }
  return context;
};
